module.exports = __webpack_public_path__ + "static/media/galeryGrass6.df4a6215.jpg";